<template lang="pug">
  #app
    .flex-container(v-if="hideLayout != true")
      .sidebar
        LogoBar(text="PositivePeopleHR")
        Navigation
      .mainbar
        Banner
        .router-container
          router-view
        Footer
    .no-container(v-else)
      router-view
</template>

<script>
import LogoBar from "@/components/navigation/LogoBar.vue";
import Banner from "@/components/navigation/Banner.vue"
import Navigation from "@/components/Navigation.vue";
import Footer from "@/components/navigation/Footer.vue";

export default {
  name: "home",
  components: {
    LogoBar,
    Banner,
    Footer,
    Navigation
  },
  computed: {
    hideLayout() {
      return this.$route.meta.hideLayout;
    }
  },
  mounted: () => {
    console.log('app mounted');
  }
};
</script>


<style lang="scss" scoped>
  $sidebar-height: calc( 100vh - #{$logo-height} );
  $mainpage-height: calc( 100vh - #{$topbar-height} );
  .sidebar {
    background: $sidebar-nav-item;
    min-height: $sidebar-height;
    width:280px;
  }
  .mainbar {
    width:100%;
    background: $gradient-0;
    display:flex;
    flex-direction: column;
    justify-content: space-between;
    .router-container {
      align-self: left;
    }
  }
  .router-container {
    padding: 0px 25px;
  }
</style>